import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import OverlayLayer from "./OverlayLayer.vue";
import { CoordFormat } from '@/utils/coord_format';
import { V4 } from '@/utils/math';

export interface ITic {
  name: string
  size: number
  mode: CoordFormat
}

@Component
export class RulerModule extends Mixins(ModuleBase) {
  persistent = {
    show: true,
    color: [0.25, 0.5, 1, 0.25] as V4,
  }

  frameStore() {
    return {
      tic: null as ITic | null,
    }
  }

  get outlet() {
    return {
      overlayLayer: OverlayLayer,
    }
  }
}
